import {INIT_URL, SIGNOUT_USER_SUCCESS, USER_DATA, USER_TOKEN_SET,UPDATE_MY_USER,
  UPDATE_THIS_USER,FETCH_START_GET_USER,ON_CHANGE_INITURL,
  ON_START_UPDATE_USER_FLAGS,
    ON_UPDATE_USER_FLAGS,
    ON_ERROR_UPDATE_USER_FLAGS,
    FETCH_ERROR_GET_USER,
    FETCH_TOKEN_EXPIR,FETCH_VALIDATION_SUCCESS,ON_OPEN_REFRESH_TOKEN,
    SET_ZERO_AUTHENTICATION,FETCH_START_INTERFACE,
    FETCH_START_FORGET_PASS,FETCH_FORGET_PASS,FETCH_FORGET_PASS_ERROR,
    FETCH_START_UPDATE_PASS,FETCH_UPDATE_PASS,FETCH_UPDATE_PASS_ERROR,
    ON_START_GET_NOTIST,ON_GET_NOTIST,ON_ERROR_GET_NOTIST,
    ON_START_GET_NOTIS,ON_GET_NOTIS,ON_ERROR_GET_NOTIS,GET_USER_PROFILE_PIC,
    FETCH_START_CHECK_USER_PASS,CHECK_USER_PASS,FETCH_ERROR_CHECK_USER_PASS,
    FETCH_START_SET_AUTHE,FETCH_START_SET_UNAUTHE,
    ON_START_GET_USER_LOGIN_HISTORY,
    ON_ERROR_GET_USER_LOGIN_HISTORY,MY_IPADDRESS,
    ON_GET_USER_LOGIN_HISTORY,GET_USER_CONNECT,
    ON_FETCH_KOPIERA_USER,ON_START_FETCH_KOPIERA_USER,
    ON_UPDATE_CURRENTUSER_FAVTALPAGEROW,ON_UPDATE_CURRENTUSER_AVTALPAGEROW,
    ON_START_USER_ATTEMPT_MORE_5,ON_USER_ATTEMPT_MORE_5,
} from "../constants/ActionTypes";
import isEmpty from 'lodash/isEmpty';

const INIT_STATE = {
  token: null,
  initURL: '',
  authUser: '',
  IpAdress: '0.0.0.0',
  currentUserPicUrl: null,
  isAuthenticated: false,
  isUpdate:false,
  user:'',
  message:'',
  isLoading:true,
  outLook:{},
  ForgetPassMessage:"",
  updateMessage:"",
  Notification:[],
  isExpireLoadig:false,
  isExpired:false,
  success:false,
  Validation:0,
  Validate:{},
  isPassCompare:false,
  Unauthorized:0,
  loginHistory: [],
  userConnect:{outlook:0,Gsuit:0},
  AttemptMessage:"",
  Attempt:0
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
     case SET_ZERO_AUTHENTICATION:{
        return INIT_STATE;
      }
     case FETCH_START_INTERFACE:{
        return INIT_STATE;
      }
      case FETCH_TOKEN_EXPIR:{
        return { 
          ...state,
          isExpired:action.payload,
          Unauthorized:0
        };
      }
      case ON_OPEN_REFRESH_TOKEN:{
        return { 
          ...state,
          isExpired:true,
        };
      }
    case FETCH_VALIDATION_SUCCESS:{
      console.log("FETCH_VALIDATION_SUCCESS",action)
      return {
        ...state,
        Validation:1,
        Validate:action.payload.Validate
      }
    }
    case INIT_URL: {
      return {...state, 
        initURL: action.payload,
        ForgetPassMessage:"",
        user:''
      };
    }
    case ON_CHANGE_INITURL: {
      return {...state, 
        initURL: action.payload
      };
    }
    case FETCH_START_GET_USER:{
      return {
        ...state,
        message:""
      }
    }
    case FETCH_ERROR_GET_USER:{
      return {
        ...state,
        message:action.payload
      }
    }

    case ON_START_GET_USER_LOGIN_HISTORY: {
      return {
        ...state,
        loginHistory: []
      }
    }
    case ON_ERROR_GET_USER_LOGIN_HISTORY: {
      return {
        ...state,
        loginHistory: []
      }
    }
    case ON_GET_USER_LOGIN_HISTORY: {
      return {
        ...state,
        loginHistory: action.payload
      }
    }

    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        token: null,
        authUser: null,
        currentUserPicUrl: null,
        initURL: '',
        isAuthenticated: false,
        ForgetPassMessage:"",
        user:''
      }
    }

    case USER_DATA: {
      console.log("USER_DATA",action.payload)
      return {
        ...state,
        user:action.payload,
        success:!isEmpty(action.payload) 
      };
    }
    case GET_USER_PROFILE_PIC: {
      console.log("GET_USER_PROFILE_PIC",action.payload)
      return {
        ...state,
        currentUserPicUrl: action.payload.ProfilePicUrl
      }
    }

    case USER_TOKEN_SET: {
      return {
        ...state,
        token: action.token,
        authUser: action.user,
        result: !isEmpty(action.user),
        expiresin : action.user.exp,
        success:action.success  ,
        isAuthenticated: !isEmpty(action.user) 
      };
    }
    case UPDATE_MY_USER: {
      console.log(action)
       return {
        ...state,
        token: action.token,
        authUser: action.user,
        result: !isEmpty(action.user),
        expiresin : action.user.exp,
        success:action.success ,
        user:action.CurrentUSer,
        isAuthenticated: !isEmpty(action.user) 
      };
    }
    //ON_UPDATE_CURRENTUSER_FAVTALPAGEROW,ON_UPDATE_CURRENTUSER_AVTALPAGEROW,
    case ON_UPDATE_CURRENTUSER_FAVTALPAGEROW: {
      console.log(action,"ON_UPDATE_CURRENTUSER_FAVTALPAGEROW")
       return {
        ...state,
        authUser: {
          ...state.authUser,
          user_FavtalPageRow:action.payload
        },
       };
    }
    case ON_UPDATE_CURRENTUSER_AVTALPAGEROW: {
      console.log(action,"ON_UPDATE_CURRENTUSER_FAVTALPAGEROW")
       return {
        ...state,
        authUser: {
          ...state.authUser,
          user_AvtalPageRow:action.payload
        },
       };
    }
    case UPDATE_THIS_USER: {
       return {
        ...state,
        result: !isEmpty(action.user),
        success:!isEmpty(action.user) ,
        message:action.message
        };
    }
    
    case ON_START_UPDATE_USER_FLAGS: {
       return {
        ...state,
        message:'',
        isLoading:true
        };
    }
    case ON_UPDATE_USER_FLAGS: {
       return {
        ...state,
        user:action.payload.user[0],
        message:'Spara',
        isLoading:false
        
        };
    }
    case ON_START_FETCH_KOPIERA_USER: {
      return {
        ...state,
        isUpdate:true
      };
    }
    case ON_FETCH_KOPIERA_USER: {
      console.log(action)
      return {
        ...state,
        user:action.payload.user[0],
        isUpdate:false,
        success:!isEmpty(action.payload) 
      };
    }
    case ON_ERROR_UPDATE_USER_FLAGS: {
       return {
        ...state,
        message:'Error',
        isLoading:false
        };
    }
    case ON_START_GET_NOTIS: {
       return {
        ...state,
        };
    }
    case ON_GET_NOTIS: {
       return {
        ...state,
        Notification:action.payload.Notification,
        };
    }
    case ON_ERROR_GET_NOTIS: {
       return {
        ...state
        };
    }
//ON_START_GET_NOTIST,ON_GET_NOTIST,ON_ERROR_GET_NOTIST,
case ON_START_GET_NOTIST: {
  return {
   ...state,
//   Notification:{}
   };
}
case ON_GET_NOTIST: {
  return {
   ...state,
   Notification:action.payload.Notification,
   };
}
case ON_ERROR_GET_NOTIST: {
  return {
   ...state
   };
}
//
case FETCH_START_FORGET_PASS: {
  return {
   ...state,
   ForgetPassMessage:"",
   updateMessage:"",
   };
}
case FETCH_FORGET_PASS: {
    console.log(action)
  return {
   ...state,
   ForgetPassMessage:action.payload,
   };
}
case FETCH_FORGET_PASS_ERROR: {
  console.log(action)
  return {
   ...state,
   ForgetPassMessage:action.payload,
   };
}
//,,,
case FETCH_START_UPDATE_PASS: {
  return {
   ...state,
   ForgetPassMessage:"",
   updateMessage:"",
   };
}
case FETCH_UPDATE_PASS: {
    console.log(action)
  return {
   ...state,
   updateMessage:action.payload,
   };
}
case FETCH_UPDATE_PASS_ERROR: {
  console.log(action)
  return {
   ...state,
   updateMessage:action.payload,
   };
}
//FETCH_START_CHECK_USER_PASS,CHECK_USER_PASS,FETCH_ERROR_CHECK_USER_PASS,
case FETCH_START_CHECK_USER_PASS: {
  return {
   ...state,
   isPassCompare:false
   };
}
case CHECK_USER_PASS: {
    console.log(action)
  return {
   ...state,
   isPassCompare:action.payload.isPassCompare
   };
}
case FETCH_ERROR_CHECK_USER_PASS: {
  console.log(action)
  return {
   ...state,   
   };
}
case FETCH_START_SET_AUTHE: {
  return {
   ...state,   
   Unauthorized:0
   };
}
case FETCH_START_SET_UNAUTHE: {
  return {
   ...state,   
  // Unauthorized:1
   };
}
//GET_USER_CONNECT
case GET_USER_CONNECT: {
  return {
    ...state,   
    userConnect:action.payload.userConnect
   };
}
//MY_IPADDRESS
case MY_IPADDRESS: {
  console.log(action)
  return {
    ...state,   
    IpAdress:action.payload
   };
}
//ON_START_USER_ATTEMPT_MORE_5,ON_USER_ATTEMPT_MORE_5,
case ON_START_USER_ATTEMPT_MORE_5: {
  return {
    ...state,
    AttemptNr:0,
    AttemptMessage:""
   };
}
case ON_USER_ATTEMPT_MORE_5: {
  console.log(action.payload,"TESTTTT")
  return {
    ...state,  
    AttemptNr:action.payload.Attempt,
    AttemptMessage :action.payload.Message
   };
}
    default:
      return state;
  }
}
